const IDLE_DELAY_MS = 8000;
const CONTAINER_ID = 'guest-idle-pulse-orbs';
const ORB_CLASS = 'guest-idle-pulse-orb';
const ORB_ACTIVE_CLASS = 'guest-idle-pulse-orb--active';
const ORB_POSITIONS = ['left', 'right'];

const ACTION_BUTTON_SELECTOR = '.member-home-action';
const ACTION_ZOOM_CLASS = 'member-home-action--idle-zoom';
const ACTION_ZOOM_STAGGER_MS = 350;

let orbs = null;
let idleTimer = null;
let suspended = false;
let listenersBound = false;
let activityFrame = 0;
let pulseOn = false;

function createOrbs() {
    const container = document.createElement('div');
    container.id = CONTAINER_ID;
    ORB_POSITIONS.forEach((position) => {
        const orb = document.createElement('div');
        orb.className = ORB_CLASS;
        orb.dataset.position = position;
        container.append(orb);
    });
    document.body.prepend(container);
    return container;
}

function startPulse() {
    if (suspended) {
        return;
    }
    pulseOn = true;
    orbs.forEach((orb) => orb.classList.add(ORB_ACTIVE_CLASS));

    document.querySelectorAll(ACTION_BUTTON_SELECTOR).forEach((button, index) => {
        button.style.setProperty('--idle-zoom-delay', `${index * ACTION_ZOOM_STAGGER_MS}ms`);
        button.classList.add(ACTION_ZOOM_CLASS);
    });
}

function stopPulse() {
    if (!pulseOn) {
        return;
    }
    pulseOn = false;
    orbs.forEach((orb) => orb.classList.remove(ORB_ACTIVE_CLASS));

    document.querySelectorAll(`.${ACTION_ZOOM_CLASS}`).forEach((button) => {
        button.classList.remove(ACTION_ZOOM_CLASS);
        button.style.removeProperty('--idle-zoom-delay');
    });
}

function scheduleIdlePulse() {
    if (idleTimer) {
        window.clearTimeout(idleTimer);
    }
    idleTimer = window.setTimeout(startPulse, IDLE_DELAY_MS);
}

function onActivity() {
    stopPulse();
    if (activityFrame) {
        return;
    }
    activityFrame = window.requestAnimationFrame(() => {
        activityFrame = 0;
        scheduleIdlePulse();
    });
}

export function initGuestIdleAttentionPulse() {
    const container = document.getElementById(CONTAINER_ID) || createOrbs();
    orbs = container.querySelectorAll(`.${ORB_CLASS}`);

    if (!listenersBound) {
        listenersBound = true;
        document.addEventListener('pointerdown', onActivity, { passive: true });
        document.addEventListener('touchstart', onActivity, { passive: true });
        document.addEventListener('mousemove', onActivity, { passive: true });
        document.addEventListener('keydown', onActivity);
    }

    scheduleIdlePulse();
}

export function suspendGuestIdleAttentionPulse() {
    if (!orbs) {
        return;
    }
    suspended = true;
    if (idleTimer) {
        window.clearTimeout(idleTimer);
        idleTimer = null;
    }
    stopPulse();
}

export function resumeGuestIdleAttentionPulse() {
    if (!orbs || !suspended) {
        return;
    }
    suspended = false;
    scheduleIdlePulse();
}
